/** Border radius scale — verbatim from source --r-* tokens. */
export const radii = {
  r1: 3,
  r2: 5,
  r3: 8,
  r4: 12,
  r5: 16,
  full: 999,
} as const;

export type Radii = typeof radii;
